// extracted by mini-css-extract-plugin
export default {"root":"_1ueMB","inline":"_1WFWP","inline-icon":"_3aOK9","inlineIcon":"_3aOK9"};